module.exports = __webpack_public_path__ + "static/media/strongher11.46d3209f.jpg";